import ChangePasswordForm from "../../components/Settings/ChangePasswordForm";
import NavSettings from "../../components/common/NavSettings";

const ChangePassword = () => {
  return (
    <>
      <NavSettings title="Mi perfil" route="Inicio" active="Cambiar contraseña" />

      <ChangePasswordForm />
    </>
  );
};

export default ChangePassword;
